export default __webpack_public_path__ + "static/media/minivistaw-comocuidartusautobuses.2f0b41be.jpg";